import React, { useState } from 'react'
import { StyleSheet, ViewStyle } from 'react-native'

import {
  DNABox,
  DNAButton,
  DNAIcon,
  DNAText,
} from '@alucio/lux-ui'
import { colors } from '@alucio/lux-ui/src/theming/themes/alucio/colors'

const styles = StyleSheet.create({
  bannerText: {
    margin: 15,
  },
  bannerBtn: {
    marginRight: 45,
  },
  container: {
    backgroundColor: colors['warning-500'],
  },
  hiddenStyle: {
    display: 'none',
  },
  icon: {
    width: 29,
    height: 24,
    marginLeft: 25,
    marginTop: 15,
    marginBottom: 15,
  },
  textColor: {
    color: colors['text-basic'],
  },
})

const NetworkConnectionBanner:React.FC<{ style?: ViewStyle }> = (props) => {
  /** Used to hide the banner while we are still offline */
  const [isHidden, setIsHidden] = useState<boolean>(false)
  const containerStyle = [
    props.style,
    styles.container,
    isHidden && styles.hiddenStyle,
  ]
  return (
    <DNABox
      spacing="between"
      alignY="center"
      fill
      style={containerStyle}
    >
      <DNABox>
        <DNAIcon
          name="wifi-off"
          status="flat"
          size="large"
          style={[styles.textColor, styles.icon]}
        />
        <DNAText b1 style={[styles.textColor, styles.bannerText]}>
          No internet connection. Some features will be unavailable in offline mode.
        </DNAText>
      </DNABox>
      <DNABox>
        <DNAButton
          onPress={() => setIsHidden(true)}
          status="warning"
          context="roundTablet"
          appearance="ghost"
          style={styles.bannerBtn}
        >
          <DNAText style={styles.textColor}>
            Hide
          </DNAText>
        </DNAButton>
      </DNABox>
    </DNABox>
  )
}

export default NetworkConnectionBanner
